import * as XLSX from 'xlsx'
import { formatAppliedFilters, extractTextFromValue } from './core'

export const exportGridToExcel = (options = {}) => {
  const filename = options.filename || 'relatorio_dados.xlsx';
  const columnsList = options.columns || [];
  const dataResult = options.filteredData || [];

  const exportColumns = columnsList.filter((col) =>
    col.Export !== 'False' && col.Export !== false
  );

  const worksheetData = dataResult.map((row) => {
    const newRow = {};
    exportColumns.forEach((col) => {
      let value = extractTextFromValue(row[col.field]);
      if (typeof value === 'string' && value.length > 32000) {
        value = value.substring(0, 32000) + '...';
      }
      newRow[col.header] = value;
    });
    return newRow;
  });

  // Preparar dados com filtros no cabeçalho se existirem
  let finalData = worksheetData;
  const filtersText = formatAppliedFilters(options.appliedFilters);
  
  if (filtersText) {
    // Criar linha de filtros no topo
    const filterRow = {};
    if (exportColumns.length > 0) {
      filterRow[exportColumns[0].header] = `Filtros aplicados: ${filtersText}`;
      // Preencher as outras colunas com vazio para manter a estrutura
      for (let i = 1; i < exportColumns.length; i++) {
        filterRow[exportColumns[i].header] = '';
      }
    }
    
    // Criar linha vazia para separação
    const emptyRow = {};
    exportColumns.forEach((col) => {
      emptyRow[col.header] = '';
    });
    
    // Combinar: filtros + linha vazia + dados
    finalData = [filterRow, emptyRow, ...worksheetData];
  }

  const ws = XLSX.utils.json_to_sheet(finalData);
  
  // Aplicar larguras das colunas se definidas
  const colWidths = exportColumns.map((col) => {
    if (col.width) {
      // Converter de diferentes formatos para caracteres
      let width = col.width;
      if (typeof width === 'string') {
        if (width.includes('px')) {
          // Converter pixels para caracteres (aproximadamente)
          const pxValue = parseInt(width.replace('px', ''));
          width = Math.max(10, Math.round(pxValue / 8)); // 8px ≈ 1 caracter
        } else if (width.includes('%')) {
          // Porcentagem: usar valor padrão baseado na porcentagem
          const percentValue = parseInt(width.replace('%', ''));
          width = Math.max(10, Math.round((percentValue / 100) * 50)); // Base de 50 caracteres
        } else if (width.includes('em') || width.includes('rem')) {
          // Em/rem: converter para caracteres
          const emValue = parseFloat(width.replace(/em|rem/, ''));
          width = Math.max(10, Math.round(emValue * 10)); // 1em ≈ 10 caracteres
        } else {
          // Se for só número, assumir que já está em caracteres
          width = parseInt(width) || 15;
        }
      } else if (typeof width === 'number') {
        width = Math.max(10, width);
      } else {
        width = 15; // valor padrão
      }
      return { wch: width };
    }
    return { wch: 15 }; // largura padrão de 15 caracteres
  });
  
  if (colWidths.length > 0) {
    ws['!cols'] = colWidths;
  }
  
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Dados');
  XLSX.writeFile(wb, filename);
};

export default exportGridToExcel


